var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bottom-fixed', {'flex':_vm.label2}]},[_c('div',{on:{"click":_vm.onBtnClick}},[_vm._v(_vm._s(_vm.label))]),(_vm.label2)?_c('div',{on:{"click":_vm.onBtn2Click}},[_vm._v(_vm._s(_vm.label2))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }